import React from 'react';
import PropTypes from 'prop-types';
import YardageRow from './yardage_row';
import ParRow from './par_row';
import StrokeRow from './stroke_row';
import LegendRow from './legend_row';
import { applyXesByHole } from '../../utils/x_score_utils';
import { scorecardTotalDisplay } from '../../utils/details_utils';
import { VIEW_MODES } from '../../constants';

const DetailsTableBody = ({ data, viewMode, holeByHoleView, label, showYardage, onToggleYardage }) => {
  const net = data.nets[0];
  const tee = net.tee;
  const nrHoles = tee.holeData.par.length;

  const strokeData = {
    strokesByHoleDisplay: applyXesByHole(net.newStrokesByHole ?? net.strokesByHole, net.xesByHole),
    pointsByHole: net.pointsByHole,
    strikethroughsStrokesByHole: net.strikethroughsByHole ?? [],
    strokeSumFront: net.strokeSumFront,
    strokeSumBack: net.strokeSumBack,
    strokeSum: scorecardTotalDisplay(net),
    dispositionCause: data.dispositionCause,
  };

  return (
    <tbody>
      {showYardage && <YardageRow tee={tee} />}
      <ParRow tee={tee} />
      <StrokeRow
        data={strokeData}
        nrHoles={nrHoles}
        label={label}
        holeByHoleView={holeByHoleView}
        showYardage={showYardage}
        onToggleYardage={onToggleYardage}
      />
      {holeByHoleView === 'colors' && <LegendRow viewMode={viewMode} holeByHoleView={holeByHoleView} />}
    </tbody>
  );
};

DetailsTableBody.propTypes = {
  data: PropTypes.object.isRequired,
  viewMode: PropTypes.oneOf(Object.values(VIEW_MODES)),
  holeByHoleView: PropTypes.string,
  label: PropTypes.string,
  showYardage: PropTypes.bool,
  onToggleYardage: PropTypes.func.isRequired,
};

export default DetailsTableBody;
